import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
  category: z.string().min(1),
  categoryColor: z.string().min(1),
  todoId: z.string().nullable().optional(),
  note: z.string().optional().default(''),
  startTime: z.string().min(1),
  endTime: z.string().min(1),
  duration: z.number().int().min(1),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  entry: {
    id: string;
    sessionId: string;
    category: string;
    categoryColor: string;
    todoId: string | null;
    note: string;
    startTime: string;
    endTime: string;
    duration: number;
    createdAt: string | null;
  };
};

export const createTimeEntry = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/time-entries/create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
